import { ChatRoom } from 'models/ChatRoom';
import { characterFor } from 'react/match/room/describeMatchRoom';

/**
 * The character for a message's stock icon. Room messages carry the sender's
 * main for the room's game. A match lobby shows the player's pick, else their
 * main, for the match's game. Direct messages have no game: they show the
 * sender's main from the open room, or any room the client knows them in.
 */
export default function senderStockCharacter(message, chatMessages) {
	if(chatMessages && chatMessages.chatRoomId) {
		return message.getSenderMain ? message.getSenderMain() : null;
	}
	if(chatMessages && chatMessages.match) {
		return characterFor(chatMessages.match, message.player) || null;
	}
	const chatRooms = message.player && message.player.chat_rooms;
	if(!chatRooms) {
		return null;
	}
	const activeMainChat = ChatRoom.getActiveMainChat();
	return chatRooms.getAnyMain(activeMainChat ? activeMainChat.id : null);
}
